module.exports = __webpack_public_path__ + "static/media/HW_FindExp_icon.ed2740a2.png";